import converter from "../../../libs/number-to-words";
import common from "../../common";
import QuestionModuleStats from "../../maths/modules/QuestionModuleStats";
import QuestionModel from "../../maths/QuestionModel";
import QuestionValueGraphLabel from "../../maths/QuestionValueGraphLabel";
import QuestionView from "./QuestionView";

export default class QuestionViewGraphBar extends QuestionView {
    constructor(question) {
        super(question);

        this._graph = new PIXI.Container();
        this._graph.position.set(0, 280);
        this.addChild(this._graph);

        this._key = new PIXI.Container();
        this._key.position.set(130, 250);
        this.addChild(this._key);

        this._confirmButton.x = this._footer.x + 400;
        this._generated = [];

        this.createGraph();

        if (question.templateType === QuestionModuleStats.TYPE_SAME) {
            this._inputField.visible = false;
        }
    }

    getHeaderText() {

        const data = P3.assets.json("templates");
        const name = data.template ? data.template : this._question.module;
        let templates = data["templates"][name][this._question.type];

        if (templates) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        }

        if (!templates || !templates.length) {
            console.error("ERROR: NO TEMPLATE FOUND");
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);
        const words = data["words"];

        let text = this._template ? this._template.text : "";

        this._graphLabelCopies = [];
        let itemLabels = words.graph_labels[this._template.graph_label || 0];

        let char_2 = this.generateWords(this._template.text, words.character_class_2, /\[CHARACTER_CLASS_TWO([0-9])?]/g);
        for (const i in char_2) {
            if (char_2.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), char_2[i]);
            }
        }

        const labelObj = {};

        let answerLabelA = null;
        let answerLabelB = null;
        let answerLabelC = null;

        //draw a random label for each value
        for (let i = 0; i < this._question.values.length; i++) {
            const itemIndex = P3.math.randomInt(0, itemLabels.length - 1);
            const itemLabel = itemLabels[itemIndex];
            this._graphLabelCopies.push(itemLabel);

            if (this._question.answerIndex.length) {
                if (i === this._question.answerIndex[0]) {
                    this._question.answer.label = itemLabel;
                } else if (i === this._question.answerIndex[1]) {
                    this._question.answer.label += "," + itemLabel;
                }
            }
            else if (i === this._question.answerIndex) {
                this._question.answer.label = itemLabel;//fill answer label if we are asked to find a label
                if (this._question.templateType === QuestionModuleStats.TYPE_LOW ||
                    this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
                    this._question.templateType === QuestionModuleStats.TYPE_EXACT) {
                    //console.log("ADDING ANSWER TO OPTIONS : " + itemLabel);
                    this._question.options.push(new QuestionValueGraphLabel(0, itemLabel));
                }
            }
            else if (i === this._question.labelIndexA) {
                answerLabelA = itemLabel;
            }
            else if (i === this._question.labelIndexB) {
                answerLabelB = itemLabel;
            }
            else if (i === this._question.labelIndexC) {
                answerLabelC = itemLabel;
            }
            else {
                labelObj["[ITEM" + i + "]"] = itemLabel;//build obj for easy swapping using regex
            }
            if ((this._question.templateType === QuestionModuleStats.TYPE_LOW ||
                this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
                this._question.templateType === QuestionModuleStats.TYPE_EXACT)
                && this._question.options.length < 5 && i !== this._question.answerIndex) {
                this._question.options.push(new QuestionValueGraphLabel(-1, itemLabel));
            }

            if (this._question.templateType === QuestionModuleStats.TYPE_SAME && this._question.options.length < this._question.values.length) {
                this._question.options.push(new QuestionValueGraphLabel(-1, itemLabel));
            }

            itemLabels.splice(itemIndex, 1);
        }

        P3.utils.shuffleArray(this._question.options);

        if (text) {

            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            const items = this.generateWords(this._template.text, words.items, /\[ITEM_([A-Za-z])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    if (i === "[ITEM_A]" && answerLabelA) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelA);
                    }
                    else if (i === "[ITEM_B]" && answerLabelB) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelB);
                    }
                    else if (i === "[ITEM_C]" && answerLabelB) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelC);
                    }
                    else {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), labelObj[i]);
                    }
                }
            }

            const values = this.generateValues(this._template.text, /\[VALUE]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), this._question.answer.value);
                }
            }
        }

        return text;
    }

    createGraph() {
        this.createBar();
    }

    createBar() {
        const addLabels = true;

        const scale = this._question.barScale ? this._question.barScale : 20;

        const offsetX = 80;
        const xWidth = 200;
        const notch = 5;

        const barGap = 5;

        //const colors = [0xff0000, 0x0000ff, 0x00ff00, 0xFFE600, 0xEF00FF, 0x00F7FF, 0xFF9A00];
        const colors = [0xFF0000, 0x0000FF, 0x2E2B5F, 0x640CAD, 0x067955, 0x8A6B00, 0x791606];

        const barWidth = Math.round(xWidth / this._question.values.length);

        const pivotWidth = 360;

        //graph bg adjusted to fit key on rhs
        this._graph.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 44, 88, 44, 88);
        this._graph.image.position.set(0, 60);
        this._graph.image.width = pivotWidth + 100;
        this._graph.image.height = 310;
        this._graph.image.pivot.set(pivotWidth * 0.5, this._graph.image.height * 0.5);
        this._graph.addChild(this._graph.image);

        //create graph lines etc
        const xAxis = new PIXI.Sprite(PIXI.Texture.WHITE);
        xAxis.tint = 0x0;
        xAxis.anchor.set(0, 0.5);

        xAxis.width = xWidth + notch;
        xAxis.height = 2;

        xAxis.x = -100;
        xAxis.y = 180;

        const yAxis = new PIXI.Sprite(PIXI.Texture.WHITE);
        yAxis.tint = 0x0;
        yAxis.anchor.set(0.5, 1);

        yAxis.width = 2;
        yAxis.height = 220;

        yAxis.x = xAxis.x;
        yAxis.y = xAxis.y;

        const totalLines = Math.floor(yAxis.height / scale);
        let modulus;
        switch (true) {
            default: {
                modulus = 1;
                break;
            }
            case totalLines > 20 && totalLines < 30: {
                modulus = 2;
                break;
            }
            case totalLines > 30 && totalLines < 40: {
                modulus = 5;
                break;
            }
        }

        //iterate and make horizontal guide lines

        for (let i = 1; i < totalLines; i++) {
            const line = new PIXI.Sprite(PIXI.Texture.WHITE);
            line.tint = 0x696969;

            line.anchor.set(0, 0.5);

            line.x = xAxis.x - notch;
            line.y = xAxis.y - i * scale;

            line.alpha = 0.3;

            line.width = 200 + notch;
            line.height = 2;

            this._graph.addChild(line);

            if (addLabels) {
                if (i % modulus === 0) {
                    const label = new PIXI.Text(i, {
                        fontSize: 14,
                        fontFamily: "BBC Reith Sans",
                        fill: 0x696969
                    });
                    line.width += 4;
                    line.x -= 4;

                    line.tint = 0x262626;

                    label.anchor.set(1, 0.5);
                    label.x = line.x - 5;
                    label.y = line.y;
                    this._graph.addChild(label);
                }
            }
        }

        //create bars
        for (let i = 0; i < this._question.values.length; i++) {
            const value = this._question.values[i].value;
            const bar = new PIXI.Sprite(PIXI.Texture.WHITE);
            bar.width = barWidth - barGap;
            bar.height = value * scale;
            bar.x = -offsetX + barWidth * i - 20;
            bar.y = 180;

            bar.anchor.set(0, 1);
            bar.tint = colors[i] !== undefined ? colors[i] : 0xd3d3d3;

            this._graph.addChild(bar);

            //create key
            const label = new PIXI.Text(this._graphLabelCopies[i].toUpperCase(), {
                fontSize: 12,
                fontFamily: "BBC Reith Sans",
                fontWeight: "bold",
                fill: 0x0
            });

            label.y = i * 30;

            label.anchor.set(0, 0.5);

            const key = new PIXI.Sprite(PIXI.Texture.WHITE);
            key.tint = colors[i] !== undefined ? colors[i] : 0xd3d3d3;

            key.x = label.x - 10;
            key.y = label.y;

            key.anchor.set(0.5);

            this._key.addChild(key);
            this._key.addChild(label);
        }

        this._graph.addChild(xAxis);
        this._graph.addChild(yAxis);
    }

    generateWords(text, options, regex) {
        const words = {};
        options = options.slice();

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const name = P3.utils.selectRandom(options);
                !words[t] && (words[t] = name);
                options.splice(options.indexOf(name), 1);
            }
        }
        return words;
    }

    generateValues(text, regex) {
        const values = {};

        //TODO - this should be set in the question rather than using type
        const useWords = this._question.type === QuestionModel.TYPE_MULTIPLICATION ?
            Math.random() < 0.5 : false;

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const match = t.match(/[0-9]/);
                const index = match ? parseInt(match[0]) : 0;
                const value = this._question.values[index].value;
                if (!values[t]) {
                    values[t] = useWords ? converter.toWords(value) : value;
                }
            }
        }
        return values;
    }

    destroy() {
        if (this._generated) {
            for (let i = 0; i < this._generated.length; i++) {
                this._generated[i].destroy(true);
            }
        }
        super.destroy();
    }

    filterTemplate(x) {
        return x.type === this._question.templateType;
    }

    isCorrect() {
        if (this._question.templateType === QuestionModuleStats.TYPE_SAME) {
            const answerArr = this._question.answer.toString().split(",");
            const answerReverse = answerArr[1] + "," + answerArr[0];
            return this._inputValue.toString() === this._question.answer.toString() || this._inputValue.toString() === answerReverse;
        }
        else if (this._question.templateType === QuestionModuleStats.TYPE_LOW ||
            this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
            this._question.templateType === QuestionModuleStats.TYPE_EXACT) {
            return this._inputValue.toString() === this._question.answer.toString();
        }
        return parseInt(this._inputValue.value) === parseInt(this._question.answer.value);
    }

    get graph() {
        return this._graph;
    }
}